module.exports = __webpack_public_path__ + "static/img/loading.2e845a1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.gif
// module id = JRsF
// module chunks = 1